class Recaptcha
{
  constructor (element, id, callback, expCallback) {
    this.id  = id;

    this.onloadCallback = this.onloadCallback.bind(this);

    window[`${this.id}`] = {
      onload:  this.onloadCallback,
      el: element,
      callback: callback,
      expCallback: expCallback
    }

    this.RecaptchaContainer = element;
    this.RecaptchaContainer.innerHTML= '';

    this.callback = callback;
    this.expCallback = expCallback;

    const recaptchaApiLink = `https://www.google.com/recaptcha/api.js?render=explicit`;

    const loadApi = new Promise((resolve, reject) => {
      let script = document.createElement("script");
      script.onload = resolve;
      script.onerror = reject;
      script.src = recaptchaApiLink;
      document.getElementsByTagName("head")[0].appendChild(script);
      setTimeout(()=>{
        window[`${this.id}`].onload();
      }, 500)  
    });
  }

  onloadCallback() {
    this.recaptcha = window.grecaptcha.render(this.RecaptchaContainer, {
      'sitekey' : process.env.RECAPTACH_SITE_KEY, // see /.env.exemple
      // SEE FormValidator
      'callback': this.callback,
      'expired-callback': this.expCallback
    });
  }
}

export default Recaptcha;
